import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import { string, bool, shape, arrayOf } from 'prop-types';
import CopyToClipboard from '@magalu/stereo-ui/molecules/CopyToClipboard';
import Box from '@magalu/stereo-ui/atoms/Box';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import Text from '@magalu/stereo-ui/atoms/Text';
import Button from '@magalu/stereo-ui/atoms/Button';
import { OpenLink } from '@magalu/stereo-ui-icons';
import { usePublisher } from '@magalu/mixer-publisher';
import withLayoutProps from '../../../../../hocs/withLayoutProps';
import useShortenLink from '../../../../../hooks/useShortenLink';
import SocialMedia from '../SocialMedia';
import ShareLinksSkeleton from '../ShareLinksSkeleton';
import SharedBag from '../SharedBag';
import { ContentInfo } from './ShareLinksActions.styles';
var ShareLinksContent = function ShareLinksContent(_ref) {
  var active = _ref.active,
    data = _ref.data,
    device = _ref.device,
    sectionSocial = _ref.sectionSocial,
    sectionSharedBag = _ref.sectionSharedBag,
    structure = _ref.structure;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    urlToCopy = _useState2[0],
    setUrlToCopy = _useState2[1];
  var channel = data.channel,
    product = data.product;
  var isDesktop = device === 'desktop';
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var _structure$asPath = structure.asPath,
    asPath = _structure$asPath === void 0 ? '' : _structure$asPath,
    _structure$basePath = structure.basePath,
    basePath = _structure$basePath === void 0 ? '' : _structure$basePath,
    _structure$config = structure.config,
    config = _structure$config === void 0 ? {} : _structure$config,
    _structure$route = structure.route,
    route = _structure$route === void 0 ? {} : _structure$route;
  var shortenlink = useShortenLink('shortenlink-onelink', {
    addPartnerId: true,
    desktopLink: "".concat(config.domain).concat(asPath),
    link: "https://m.magazineluiza.com.br".concat(asPath == null ? void 0 : asPath.split(basePath).join(''))
  });
  useEffect(function () {
    if (!active) return;
    var url = sessionStorage.getItem("shorten_onelink");
    var sku = sessionStorage.getItem("sku");
    if (!url || url === 'null' || url === 'undefined' || sku !== route.productId) {
      setUrlToCopy('');
      shortenlink.handleShortenLink();
    } else setUrlToCopy(url);
  }, [structure, active]);
  useEffect(function () {
    if (shortenlink.shortLink) {
      sessionStorage.setItem('shorten_onelink', shortenlink.shortLink);
      sessionStorage.setItem('sku', route.productId);
      setUrlToCopy(shortenlink.shortLink);
    }
  }, [shortenlink.shortLink]);
  useEffect(function () {
    if (shortenlink.isLoading) {
      setUrlToCopy('');
    }
  }, [shortenlink.isLoading]);
  var handleEventCopy = function handleEventCopy() {
    publish('pmd:sharelinks:share:product:click', {
      pageType: structure == null ? void 0 : structure.name,
      productId: structure == null ? void 0 : structure.route.productId,
      productName: structure == null ? void 0 : structure.route.slug,
      shareAction: 'copiar-link'
    });
  };
  var handleAddToReadyBagEvent = function handleAddToReadyBagEvent() {
    publish('pmd:sharelinks:add:ready:bag:click', {
      productId: structure == null ? void 0 : structure.route.productId,
      productName: isDesktop ? structure == null ? void 0 : structure.route.slug : structure == null ? void 0 : structure.route.productSlug
    });
  };
  var renderLoadingSkeleton = function renderLoadingSkeleton() {
    return React.createElement(ContentInfo, {
      "data-testid": "share-links-actions"
    }, isDesktop && React.createElement(React.Fragment, null, React.createElement(ShareLinksSkeleton, {
      width: "100%",
      variation: "text"
    }), React.createElement(ShareLinksSkeleton, {
      width: "100%",
      height: "52px",
      variation: "rectangular"
    })), React.createElement(ShareLinksSkeleton, {
      width: "100%",
      variation: "text"
    }), React.createElement(Flex, {
      justifyContent: "flex-start",
      gap: "20px"
    }, React.createElement(Flex, {
      flexDirection: "column",
      alignItems: "center",
      gap: "8px"
    }, React.createElement(ShareLinksSkeleton, {
      width: "44px",
      height: "44px",
      variation: "circular"
    }), React.createElement(ShareLinksSkeleton, {
      width: "60px",
      variation: "text"
    })), React.createElement(Flex, {
      flexDirection: "column",
      alignItems: "center",
      gap: "8px"
    }, React.createElement(ShareLinksSkeleton, {
      width: "44px",
      height: "44px",
      variation: "circular"
    }), React.createElement(ShareLinksSkeleton, {
      width: "60px",
      variation: "text"
    }))), React.createElement(ShareLinksSkeleton, {
      width: "100%",
      height: "32px",
      variation: "rectangular"
    }));
  };
  var renderError = function renderError() {
    if (shortenlink.error.status === 401) return React.createElement(Flex, {
      flexDirection: "column",
      alignItems: "center",
      gap: "10px"
    }, React.createElement(Text, {
      color: "error.text",
      lineHeight: "1.2"
    }, "Ops! Parece que voc\xEA precisa fazer login no admin novamente para continuar."), React.createElement(Button, {
      as: "a",
      variation: "outline",
      href: "/login",
      target: "_blank",
      rel: "noopener noreferrer",
      size: "small",
      endIcon: React.createElement(OpenLink, {
        width: 20,
        height: 20
      }),
      full: true
    }, "Ir para o login"));
    return React.createElement(Text, {
      color: "error.text",
      lineHeight: "1.2"
    }, "Poxa! Algo deu errado. Por favor, espere um pouquinho e tente de novo.");
  };
  var renderShareOptions = function renderShareOptions() {
    var _channel$data$, _channel$data$$value, _structure$config2;
    if (shortenlink.isLoading) return renderLoadingSkeleton();
    if (shortenlink.hasError) return renderError();
    return React.createElement(React.Fragment, null, isDesktop && React.createElement(Box, null, React.createElement(Text, {
      fontSize: 1,
      fontWeight: "regular",
      mb: 2
    }, "Link do produto"), React.createElement(Box, {
      onClick: handleEventCopy,
      "data-testid": "desk-copy-link-button"
    }, React.createElement(CopyToClipboard, {
      value: urlToCopy
    }))), React.createElement(SocialMedia, {
      "data-testid": "share-socialmedia",
      sectionSocial: sectionSocial,
      device: device,
      urlToCopy: urlToCopy,
      structure: structure
    }), React.createElement(SharedBag, {
      "data-testid": "share-bag",
      sectionSharedBag: sectionSharedBag,
      product: product,
      storeNumericId: channel == null ? void 0 : (_channel$data$ = channel.data[1]) == null ? void 0 : (_channel$data$$value = _channel$data$.value) == null ? void 0 : _channel$data$$value.id,
      cookieDomain: structure == null ? void 0 : (_structure$config2 = structure.config) == null ? void 0 : _structure$config2.cookieDomain,
      onAddToReadyBagEvent: handleAddToReadyBagEvent
    }));
  };
  return React.createElement(ContentInfo, {
    "data-testid": "share-links-actions"
  }, renderShareOptions());
};
process.env.NODE_ENV !== "production" ? ShareLinksContent.propTypes = {
  active: bool,
  data: shape({
    product: shape({
      image: string,
      title: string
    })
  }),
  device: string,
  sectionSharedBag: shape({
    buttonLabel: string,
    show: string,
    url: string
  }),
  sectionSocial: shape({
    buttons: arrayOf(shape({
      color: string,
      eventType: string,
      href: string,
      name: string
    })),
    title: string
  }),
  structure: shape({})
} : void 0;
ShareLinksContent.defaultProps = {
  active: false,
  data: {},
  device: 'mobile',
  sectionSharedBag: {
    buttonLabel: 'Adicionar à Sacola Pronta',
    show: 'false',
    url: '#'
  },
  sectionSocial: {
    title: 'Compartilhe nas redes sociais'
  },
  structure: {}
};
export default withLayoutProps(ShareLinksContent);